<router-outlet></router-outlet>

<!-- Shared device bar (id / version + settings gear) — shown while nobody is signed in.
     Signed-in screens keep the same info in the waiter sidebar footer, which also holds
     the settings menu entry. The gear itself stays server-gated (WS "config" →
     showSettingsButton, ~10s): the socket is bound to the device by the `udid` frame
     regardless of sign-in, so the backoffice can reveal it on the login screen too. -->
<app-device-info-bar
  *ngIf="onLogin"
  [devMode]="!environment.production"
  [adminUnlocked]="settingsButtonRevealed"
  (openSettings)="router.navigate(['/app/devicesettings'])"
></app-device-info-bar>
